import { ActivityType } from 'src/modules/common/types';

export const getActivityRoutes: (
  activityType: ActivityType,
  payload: Record<string, string>
) => string = (activityType: ActivityType, payload: Record<string, string>) => {
  switch (activityType) {
    case ActivityType.UPDATE_ESG_VALUE:
    case ActivityType.PROCESSED_SUBMITTED_ESG_VALUE:
    case ActivityType.DEACTIVATE_ESG_VALUE:
    case ActivityType.ACTIVATE_ESG_VALUE:
    case ActivityType.ASSIGN_ESG_VALUE:
    case ActivityType.CREATE_PROOF_DOCUMENT:
    case ActivityType.DELETE_PROOF_DOCUMENT:
    case ActivityType.CREATE_KPI_COMMENT:
    case ActivityType.DELETE_KPI_COMMENT:
      return `/data-management/collect/${payload.collectOverviewId}`;
    case ActivityType.SUBMIT_ESG_VALUE_FOR_APPROVAL:
      return `/data-management/collect/${payload.collectOverviewId}/approval`;
    case ActivityType.REGISTER:
    case ActivityType.DELETE_USER:
      return 'settings/manage-team';
    case ActivityType.DELETE_FACILITY:
    case ActivityType.CREATE_FACILITY:
      return `/settings/manage-facility`;
    case ActivityType.ASSIGN_REPORT_CHAPTER:
    case ActivityType.UPDATE_REPORT_CHAPTER:
    case ActivityType.MARK_REPORT_CHAPTER_AS_COMPLETE:
    case ActivityType.MARK_REPORT_CHAPTER_AS_INCOMPLETE:
      return `/reports/${payload.reportId}/section/${payload.reportSectionId}`;
    case ActivityType.DELETE_REPORT:
    case ActivityType.CREATE_REPORT:
      return `/reports`;
    default:
      return '/';
  }
};
